import { Box } from 'wix-style-react';
import * as React from 'react';
import { InfoLine } from './InfoLine';
import { translate } from 'react-i18next';
export var DocumentCustomFields = translate()(function (_a) {
    var documentCustomFields = _a.documentCustomFields, t = _a.t;
    var getCustomFields = function () { return (React.createElement(Box, { dataHook: "document-custom-fields", direction: "vertical" }, documentCustomFields
        .filter(function (_a) {
        var value = _a.value, displayName = _a.displayName;
        return !!value && !!displayName;
    })
        .map(function (_a, index) {
        var displayName = _a.displayName, value = _a.value;
        return (React.createElement(InfoLine, { key: index, dataHook: "".concat(displayName, "-").concat(index, "-custom-field") }, t('invoice-view:price-quote.view.custom-field', {
            displayName: displayName,
            value: value,
        })));
    }))); };
    return documentCustomFields && documentCustomFields.length > 0
        ? getCustomFields()
        : null;
});
//# sourceMappingURL=DocumentCustomFields.js.map